import { Component, OnInit, OnDestroy } from '@angular/core';
import { OrderValidator } from 'src/app/shared/order';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { setModalContract } from 'src/app/redux/actions/options.action';
import { NAVEGATION } from 'src/app/shared/const/navegation';
import { DateChecker } from '@shared-logic/utils';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import { ContractProcessResult } from '@shared-logic/integration-ibm';
import { ATANOR_CODE_SELLER, SYNGENTA_CODE_SELLER } from '@shared-logic/subjects';

@Component({
  selector: 'dialog-contract-create',
  templateUrl: './dialog.html',
  styleUrls: ['./dialog.scss', '../modal.scss']
})
export class DialogContractCreate implements OnInit, OnDestroy {
  hour: string = '';
  mensaje: string = 'El nuevo borrador fue enviado a boletos para su aprobación bajo el N° de contrato:';
  moreInfo: string = 'Su número es: ';
  arrayOfSuccess!: ContractProcessResult[];
  location: string = '';
  isConfirm: boolean = true;

  optionsSubscription!: Subscription;
  constructor(private store: Store<appState>, private date: DateChecker, private orderV: OrderValidator) { }

  ngOnInit(): void {
    this.hour = this.date.setHourFormat();

    this.optionsSubscription = this.store.select('options').subscribe(optionsR => {
      this.arrayOfSuccess = optionsR.modalContract.arrayOfSuccess;
      this.location = optionsR.location;
    });
  }

  ngOnDestroy(): void {
    this.optionsSubscription.unsubscribe();
  }

  close() {
    this.store.dispatch(setModalContract({ modalContract: { isShow: false, arrayOfFaileds: [], arrayOfSuccess: [], isIndicators: false, typeModal: 0 } }));
  }



  getClientName(success: ContractProcessResult) {

    if (success.sellerCode === SYNGENTA_CODE_SELLER) return 'Syngenta Agro-AVC';
    if (success.sellerCode === ATANOR_CODE_SELLER) return 'Atanor';
    return this.orderV.getSellerNameByCode(success.sellerCode);
  }

  isExchange() {
    return this.location == NAVEGATION.ORDER_EXCHANGE;
  }
}